"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrayDistinctItem = void 0;
/**
 * unikalne wiersze z tablicy
 * @param array tablica do sumowania
 * @param prop pole do określenia unikalności wiersza
 */
function arrayDistinctItem(array, prop) {
    const $result = [];
    const $distinct = {};
    if (prop) {
        for (let i = 0; i < array.length; i++) {
            const $v = array[i][prop];
            if ($distinct[$v] === undefined) {
                $result.push(array[i]);
                $distinct[$v] = i;
            }
        }
    }
    else {
        for (let i = 0; i < array.length; i++) {
            if ($distinct[array[i]] === undefined) {
                $result.push(array[i]);
                $distinct[array[i]] = i;
            }
        }
    }
    return $result;
}
exports.arrayDistinctItem = arrayDistinctItem;
//# sourceMappingURL=arrayDistinctItem.js.map